const statusGroup = {
  UNASSIGNED: 'UNASSIGNED',
  ASSIGNED: 'ASSIGNED',
  FINISHED: 'FINISHED',
};

const statusObject = {
  PENDING_ASSIGNMENT: statusGroup.UNASSIGNED,
  IN_TRANSIT: statusGroup.ASSIGNED,
  ASSIGNED: statusGroup.ASSIGNED,
  DONE_WITHOUT_MANIFEST: statusGroup.FINISHED,
  DONE: statusGroup.FINISHED,
  CANCELLED: statusGroup.FINISHED,
  DONE_WITH_CANCELLATIONS: statusGroup.FINISHED,
};

export const DEFAULT_SIDEBAR_TAB = 'LOGS';

export { statusGroup, statusObject };
